import React, { useState } from "react";
import { Link } from "react-router-dom";
import "styles/scss/recruitment.scss";
import TopButton from "components/topbutton/TopButton";

function Recruitment() {
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  return (
    <>
    <div className="recruitment">
      <div className="infor-background">
      <TopButton />
        <h1>인재채용</h1>
        <p>[ 인재상 / 복리후생 ]</p>
      {/* 브레드크럼 */}
      <div className="breadcrumb-box container">
        <nav className="breadcrumb">
        <ul>
        <li className="home-icon">
        <Link to="/">
                    <span className="home"></span>
                </Link>
        </li>        
        <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        인재채용
        <span className="dropdown-icon">
        {isCompanyDropdownOpen ? "▲" : "▼"}
        </span>
        {isCompanyDropdownOpen && (
            <ul className="dropdown-menu">
            <li>
                <Link to="/about">회사소개</Link>
            </li>
            <li>
                <Link to="/business">비즈니스</Link>
            </li>
            <li>
                <Link to="/news">N소식</Link>
            </li>
            <li>
                <Link to="/recruitment">인재채용</Link>
            </li>
            </ul>
        )}
        </li>
      </ul>
        </nav>

          <div className="mobile">
            <ul>
              <li className="home-icon">
                <Link to="/">
                    <span className="home"></span>
                </Link>
              </li>
              <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                   인재채용
                <span className="dropdown-icon">
                {isCompanyDropdownOpen ? "▲" : "▼"}
                </span>
                {isCompanyDropdownOpen && (
                    <ul className="dropdown-menu">
                    <li>
                        <Link to="/about">회사소개</Link>
                    </li>
                    <li>
                        <Link to="/business">비즈니스</Link>
                    </li>
                    <li>
                        <Link to="/news">N소식</Link>
                    </li>
                    <li>
                        <Link to="/recruitment">인재채용</Link>
                    </li>
                    </ul>
                )}
                </li>
            </ul>
        </div>
        </div>
      </div>

      <div className="recruitment-con">
        {/* 엔정보기술 - 인재상 */}
        <ul className="container">
          <li className="tit">
            <h2>인재상</h2>
          </li>
          <li className="txt">
            <p>"즐겁게 일할 수 있는 환경, 더 나은 미래를 꿈꾸는 사람들. <br></br>
            엔정보기술과 함께라면 <span>당신의 커리어는 새로운 가능성을 만나게 됩니다.</span>"</p>
          </li>
          <li className="recruitment-roundBox">
            <ul>
              <li>
                <div className="roundBox roundBox01"></div>
                <p>꿈과 열정을 가지고<br></br>도전하는 사람</p>
              </li>
              <li>
                <div className="roundBox roundBox02"></div>
                <p>고객을 최우선으로 생각하고 <br></br>끊임없이 혁신하는 사람</p>
              </li>
              <li>
                <div className="roundBox roundBox03"></div>
                <p>팀워크를 이루며 자율적이고<br></br> 창의적으로 일하는 사람</p>
              </li>
              <li>
                <div className="roundBox roundBox04"></div>
                <p>꾸준히 실력을 <br></br>배양하는 사람</p>
              </li>
            </ul>
          </li>
        </ul>
        {/* 사람인 링크 */}
        <div className="link">
          <p>자세한 사항은 사람인 사이트를 확인해주시기 바랍니다.</p>
          <div>
            <a href="https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=d2R3ZUc5a1ltM3lWL2ZwY0JNMTRuQT09" target="blank">사람인 바로가기 <span className="arrow-icon"></span></a>
          </div>
        </div>
        {/* 복리후생 */}
        <div className="benefit">
          <h2>복리후생</h2>
          <p>"당신의 일상이 더 행복하도록, <span className="red">엔정보기술</span> 이 챙깁니다."</p>
          <ul className="benefit-ul">
          <li>
              <div className="icon icon01"></div>
              <div className="benefit-txt">생일 식사비 지원</div>
            </li>
            <li>
              <div className="icon icon02"></div>
              <div className="benefit-txt">재택근무 or 유연근무제</div>
            </li>
            <li>
              <div className="icon icon03"></div>
              <div className="benefit-txt">자율복장</div>
            </li>
            <li>
              <div className="icon icon04"></div>
              <div className="benefit-txt">사우회(경조사회)</div>
            </li>
            <li>
              <div className="icon icon05"></div>
              <div className="benefit-txt">사내스낵바</div>
            </li>
            <li>
              <div className="icon icon06"></div>
              <div className="benefit-txt">문화생활비 지원</div>
            </li>
            <li>
              <div className="icon icon08"></div>
              <div className="benefit-txt">격려금</div>
            </li>
            <li>
              <div className="icon icon10"></div>
              <div className="benefit-txt">4대보험 가입</div>
            </li>
            <li>
              <div className="icon icon08"></div>
              <div className="benefit-txt">퇴직연금(DB,DC제도)</div>
            </li>
            <li>
              <div className="icon icon10"></div>
              <div className="benefit-txt">단체보험</div>
            </li>
            <li>
              <div className="icon icon08"></div>
              <div className="benefit-txt">각종경조사지원</div>
            </li>
            <li>
              <div className="icon icon16"></div>
              <div className="benefit-txt">차량유류비지원</div>
            </li>
            <li>
              <div className="icon icon17"></div>
              <div className="benefit-txt">대명콘도회원권</div>
            </li>
            <li>
              <div className="icon icon08"></div>
              <div className="benefit-txt">휴일근무수당</div>
            </li>
          </ul>
        </div>
      </div>
  </div>
    </>
  );
}

export default Recruitment;